__turbopack_context__.v({
  "className": "raleway_a8a5aa8a-module__Iw-ntW__className",
  "variable": "raleway_a8a5aa8a-module__Iw-ntW__variable",
});
